import { gql } from '@apollo/client';

export const CLARKE_GROUPS_REPORT_QUERY = gql`
  query GetClarkeGroupsReport(
    $page: Int
    $limit: Int
    $term: String
    $nameFilter: String
    $clientIdFilter: String
    $legalNameFilter: String
    $docTypeFilter: String
    $docNumberFilter: String
    $exposure: Int
    $profile: Int
    $status: LifecycleStatus
    $statusIsNull: Boolean
    $crmIdFilter: String
    $accountManagerIdFilter: String
    $clientSinceFrom: String
    $clientSinceTo: String
    $churnDateFrom: String
    $churnDateTo: String
    $createdAtFrom: String
    $createdAtTo: String
    $updatedAtFrom: String
    $updatedAtTo: String
    $volumeMwmMin: Float
    $volumeMwmMax: Float
    $exposurePercentageMin: Float
    $exposurePercentageMax: Float
    $companiesCountMin: Int
    $companiesCountMax: Int
    $unitsCountMin: Int
    $unitsCountMax: Int
    $sortBy: String
    $sortOrder: String
    $nullKpi: String
  ) {
    clarkeGroupsReport(
      page: $page
      limit: $limit
      term: $term
      nameFilter: $nameFilter
      clientIdFilter: $clientIdFilter
      legalNameFilter: $legalNameFilter
      docTypeFilter: $docTypeFilter
      docNumberFilter: $docNumberFilter
      exposure: $exposure
      profile: $profile
      status: $status
      statusIsNull: $statusIsNull
      crmIdFilter: $crmIdFilter
      accountManagerIdFilter: $accountManagerIdFilter
      clientSinceFrom: $clientSinceFrom
      clientSinceTo: $clientSinceTo
      churnDateFrom: $churnDateFrom
      churnDateTo: $churnDateTo
      createdAtFrom: $createdAtFrom
      createdAtTo: $createdAtTo
      updatedAtFrom: $updatedAtFrom
      updatedAtTo: $updatedAtTo
      volumeMwmMin: $volumeMwmMin
      volumeMwmMax: $volumeMwmMax
      exposurePercentageMin: $exposurePercentageMin
      exposurePercentageMax: $exposurePercentageMax
      companiesCountMin: $companiesCountMin
      companiesCountMax: $companiesCountMax
      unitsCountMin: $unitsCountMin
      unitsCountMax: $unitsCountMax
      sortBy: $sortBy
      sortOrder: $sortOrder
      nullKpi: $nullKpi
    ) {
      page
      total
      limit
      indicators {
        totalGroups
        totalCompanies
        totalUnits
        totalVolumeMwm
        nullKpis {
          name
          legalName
          docType
          docNumber
          companiesCount
          unitsCount
          volumeMwm
          exposure
          exposurePercentage
          profile
          status
          crmId
          accountManager
          clientSince
        }
      }
      data {
        id
        name
        legalName
        docType
        docNumber
        companiesCount
        unitsCount
        volumeMwm
        exposure
        exposurePercentage
        profile
        status
        clientSince
        churnDate
        createdAt
        updatedAt
        organizationId
      }
    }
  }
`;
